<template>
  <header
    :class="adminMode ? 'top-bar-admin' : 'top-bar-not-admin'"
    id="top-bar"
    style="min-width: 40em"
  >
    <nav id="nav-bar">
      <div id="nav-bar-brand">
        <a href="/">
          <!--suppress HtmlUnknownTarget -->
          <img
            src="@/presentation/assets/img/logo.svg"
            alt="Sundata"
            style="height: 70%"
          />
        </a>
      </div>
      <ul id="nav-bar-side-menu" class="mr-4">
        <li>
          <company-picker v-if="admin" />
        </li>
        <li class="mx-1">
          <search-cart />
        </li>
        <li class="mx-1">
          <NotificationsButton />
        </li>
        <li>
          <user-avatar
            :user="user"
            @click="toggleMenu"
            aria-haspopup="true"
            aria-controls="overlay_menu"
            class="mx-2 cursor-pointer"
            style="height: 2.4rem; width: 2.4rem"
          />
          <Menu ref="menu" id="overlay_menu" :model="items" :popup="true">
            <template #start>
              <div v-if="admin" class="flex flex-row mx-2">
                <div class="flex-auto mr-2 leading-9">Admin mode</div>
                <admin-mode-switch class="mt-2 float-right" />
              </div>
              <div v-if="admin" class="flex flex-row mx-2">
                <div class="flex-auto mr-2 leading-9">Plant Tabs</div>
                <plant-as-tabs-switch class="mt-2 float-right" />
              </div>
              <language-picker class="mx-2 mb-2" />
            </template>
          </Menu>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script lang="ts">
import type Menu from 'primevue/menu';
import SignOutService from '@/domain/authentication/services/SignOutService.ts';
import User from '@/domain/model/business/User.ts';
import CompanyPicker from '@/presentation/components/topbar/CompanyPicker.vue';
import NotificationsButton from '@/presentation/components/topbar/NotificationsButton.vue';
import PlantAsTabsSwitch from '@/presentation/components/topbar/PlantAsTabsSwitch.vue';
import SearchCart from '@/presentation/components/topbar/SearchCart.vue';
import UserAvatar from '@/presentation/components/users/UserAvatar.vue';
import AdminModeSwitch from './AdminModeSwitch.vue';
import LanguagePicker from './LanguagePicker.vue';

export default {
  name: 'TopBar',
  components: {
    NotificationsButton,
    PlantAsTabsSwitch,
    AdminModeSwitch,
    SearchCart,
    CompanyPicker,
    LanguagePicker,
    UserAvatar,
  },
  props: {
    admin: { required: true },
    adminMode: { required: true },
    user: { type: User, required: true },
  },
  computed: {
    items() {
      return [
        {
          separator: true,
        },
        {
          label: this.$t('global.account'),
          icon: 'pi pi-user',
          command: () => this.navAccountPage(),
        },
        {
          label: this.$t('global.log_out'),
          icon: 'pi pi-sign-out',
          command: () => this.signOut(),
        },
      ];
    },
  },
  methods: {
    toggleMenu(event) {
      (this.$refs.menu as InstanceType<typeof Menu>).toggle(event);
    },
    signOut() {
      new SignOutService().signOut().then((signedOut) => {
        if (signedOut) {
          window.location.replace('/');
        }
      });
    },
    navAccountPage() {
      this.$router.push({ name: 'Account' });
    },
  },
};
</script>
